import { render, staticRenderFns } from "./KidemTazminatiHesaplayici.vue?vue&type=template&id=6521edc0"
import script from "./KidemTazminatiHesaplayici.vue?vue&type=script&lang=ts"
export * from "./KidemTazminatiHesaplayici.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports